// extracted by mini-css-extract-plugin
export default {"footer":"components-billing-admins-modal-add-user-module__footer"};